export enum RoleEnum {
  Admin = 1,
  Requestor = 2,
  CentralQaTeam = 3,
  SalesRepresentative = 4,
  Investigator = 5,
  TaskActionOwner = 6,
  CorrectiveActionOwner = 7,
}
